import { Link } from 'react-router-dom';

function Footer() {
  return (
    <footer className="py-8 font-serif text-sm text-white bg-gray-800 md:py-10">
      <div className="md:mx-auto md:max-w-3xl">
        <div className="flex items-center justify-between leading-snug px-2.5">
          <div className="flex flex-col md:flex-row">
            <div className="text-white md:mr-8 text-opacity-55">
              All content &copy; 2021 Shield PAC
            </div>
            <div>
              <Link to="/privacy" className="text-white text-opacity-80">
                Privacy Policy
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
